import { TEIQspinner } from './ui';
import { iLoadingSpinnerProps } from '../types';

export const LoadingSpinner = ({ isLoading, content, keepMounted = false }: iLoadingSpinnerProps) => {
    // keepMounted: never unmount page content (e.g. during Cognito soft refresh after Mac unlock).
    if (keepMounted) {
        return <>{content}</>;
    }

    return isLoading ? (
        <div className="loading-spinner">
            <TEIQspinner variant="lg" label="Loading" />
        </div>
    ) : (
        <>{content}</>
    );
};
